import styled from 'styled-components/native'
import I18n from 'APP/I18n'
import Typography from 'APP/Converse/Typography'

const Container = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin / 3}px;
`
const TotalsLine = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const TotalAmountContainer = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin / 4}px;
  flex-direction: row;
  align-items: end;
`
export const TotalsSection = ({ totalAmount }: { totalAmount: number }) => {
  return (
    <Container testID="TOTALS_SECTION_CONTAINER">
      <TotalsLine>
        <Typography variant="bodyLargeBold">
          {I18n.t('Checkout.TotalsSection.totalDue')}:
        </Typography>
        <TotalAmountContainer>
          <Typography variant="h2">${totalAmount} CAD</Typography>
        </TotalAmountContainer>
      </TotalsLine>
      <Typography variant="bodySmall">{I18n.t('InsuranceReimbursementNotice.body')}</Typography>
    </Container>
  )
}

export default TotalsSection
